import Vue from "vue";
import Vuex from "vuex";

import {
  sponsorGroupResource,
  formResource,
  formUpdateResource,
} from "./api/resources";

Vue.use(Vuex);

export default new Vuex.Store({
  state: { groups: [], selectedGroup: null },
  mutations: {
    setGroups(state, payload) {
      state.groups = payload;
    },

    setSelectedGroup(state, payload) {
      state.selectedGroup = payload;
    },
  },
  actions: {
    setSelectedGroup({ commit }, groupId) {
      commit("setSelectedGroup", groupId);
    },

    async getGroups({ commit }) {
      const groups = await sponsorGroupResource.get("", {
        params: { hide: false },
        headers: {
          "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
        },
      });
      commit("setGroups", groups.data.results);
    },

    async submitReservation(x, reservation) {
      await formResource.post("", reservation, {
        headers: {
          "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
        },
      });

      await formUpdateResource(
        reservation.sponsorGroupId._id || reservation.sponsorGroupId
      ).patch(
        "",
        {
          $push: {
            sponsors: {
              title: reservation.vendorName,
              url: reservation.vendorUrl,
              image: reservation.logo,
            },
          },
        },
        {
          headers: {
            "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
          },
        }
      );
    },
  },
  getters: {
    freeGroups: (state) => state.groups.filter((group) => !group.occupied),

    selectedGroup: (state) => state.selectedGroup,
  },
});
